<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>

    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>成绩管理</p>
        </div>
        <div class="organiza-list" :class="obj.cert_id?'organiza-list1':''">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataLists">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <div class="item-txt">
                <p v-for="(ele,num) in item.scores" v-bind:key="(num+1)">{{ele.score}}</p>
                <p title="详情" @click="lookDetail(item)">详情</p>
              </div>
            </div>
          </div>
        </div>
        <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
      </div>
    </div>

    <!-- 添加提示框 -->
    <div class="msgBox tipsBox addTips" v-if="addTip">
      <div class="contv">
        <p class="title">{{detailData.name}}</p>
        <div class="list">
          <div class="detail-title">
            <p>模拟卷名称</p>
            <p>听力</p>
            <p>语用</p>
            <p>阅读</p>
            <p>总分</p>
          </div>
          <div class="detail-list">
            <div class="list-item" v-for="(item,index) in detailList" :key="(index+1)">
              <p>{{item.name}}</p>
              <p>{{item.listening}}</p>
              <p>{{item.language}}</p>
              <p>{{item.reading}}</p>
              <p>{{item.score}}</p>
            </div>
          </div>
        </div>
        <div class="btnBox">
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navBox from "./../components/comment/nav.vue";
import myHeader from "./../components/comment/myHeader.vue";
import { getChildrenResultList,getChildrenResultDetail } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId: "8",
      titleList: [
        { id: 11, title: "姓名" },
        { id: 12, title: "手机号" },
      ],
      dataList: [],
      currentPage1: 2,
      removeType: false,
      topicType: [
        { id: 1, title: "单选题" },
        { id: 2, title: "多选题" },
        { id: 3, title: "判断题" },
      ],
      showType: "list",
      addTip: false,
      obj: {
        page: 1,
        rows: 10,
      },
      token: "",
      totalPage: 0,
      userData: {
        authority: [],
      },
      url: "",
      detailData:'',
      detailObj:{
        page:1,
        rows:10,
        children_id:'',
      },
      detailList:[],
    };
  },
  components: {
    navBox,
    myHeader,
  },
  watch: {
    $route() {
    },
  },
  mounted() {
    var that = this;
    this.userData = this.$refs.navBox.userData;
    this.token = this.userData.token;
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    closeSub() {
      this.addTip = false;
      this.detailList = [];
    },

    getList() {
      var that = this;
      getChildrenResultList(this.obj, this.token).then((res) => {
        var data = res.data;
        if (data.code == 200) {
          that.titleList= [
            { id: 11, title: "姓名" },
            { id: 12, title: "手机号" },
          ];
          that.dataList = data.data.list;
          data.data.test.forEach(function (item, index) {
            that.titleList.push({ id: item.id, title: item.name });
          });
          that.titleList.push({ id: that.titleList.length+1, title: "操作" });
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      });
    },

    numCheck(e, i, type) {
      var that = this;
      var num = e;
      num = num.length;
      if (num > i) {
        if (type == "mobile") {
          e = e.slice(0, 11);
          that.addObj.mobile = e;
        } else {
          that.code = JSON.stringify(e).slice(0, 4);
        }
      }
    },


    lookDetail(e){
      var that = this;
      this.detailData = e;
      this.detailObj.children_id = e.children_id;
      this.addTip = true;
      getChildrenResultDetail(this.detailObj, this.token).then((res) => {
        var data = res.data;
        if (data.code == 200) {
          that.detailList = data.data.list;
        } else {
          that.$message(data.msg);
        }
      });
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p {
  width: 10%;
}

.organiza-list1 .dataList .listItem p,
.organiza-list1 .titleList p {
  width: calc(100% / 7);
}

.organiza-list {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
}

.organiza-list .listItem,
.organiza-list .titleList {
  width: 100%;
  white-space: nowrap;
}

.organiza-list::-webkit-scrollbar {
  height: 4px;
}

.item-txt {
  display: inline-block;
  vertical-align: top;
  font-size: 0;
  width: 100%;
}

/* .item-txt p{
  width: 9%;
} */
.list{
  height: 80%;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 20px;
}
.dataList {
  overflow-x: none;
}
.list-item,
.detail-title{
  font-size: 0;
}
.list-item p,
.detail-title p{
  display: inline-block;
  font-size: 14px;
  color: #333;
  width: 120px;
  padding: 20px 0;
}
.tipsBox .contv{
  height: 80%;
}
</style>



// WEBPACK FOOTER //
// src/student/score.vue